import { CouplePaginate, CoupleType, PairedPersonType, PairingResponse, PersonPaginate, PersonType } from "../types/PersonType";
import { useAPI } from "../hooks/useAPI";
import { OptionType, ResponseErrorType } from "../types/CommonType";
import { MedicalRecordEvolutionType, MedicalRecordType } from "../types/MedicalRecordType";
import { MedicationMetaType, TreatmentResultType, TreatmentType } from "../types/TreatmentType";
import { ExamResponse, ExamResultType, ExamType } from "../types/ExamType";
import { DocumentModelType, DocumentType } from "../types/DocumentType";

export function DocumentModel() {
    const { api } = useAPI();

    const create = async (document: DocumentType, medical_record_id: number) => {
        return new Promise<ResponseErrorType | DocumentType>((resolve) => {
            api()
                .post(`/api/medical-record/${medical_record_id}/document`, document)
                .then((resp) => {
                    resolve(resp.data.document);
                })
                .catch((err) => {
                    resolve({ code: err.response.status, message: err.response.data.message, error: true })
                });
        });
    }

    const update = async (document_id: number, document: DocumentType) => {
        return new Promise<ResponseErrorType | DocumentType>((resolve) => {
            api()
                .put(`/api/medical-record/${document.medical_record_id}/document/${document_id}`, document)
                .then((resp) => {
                    resolve(resp.data.document);
                })
                .catch((err) => {
                    resolve({ code: err.response.status, message: err.response.data.message, error: true })
                });
        });
    }

    const updateModel = async (model_id: number, model: DocumentModelType) => {
        return new Promise<ResponseErrorType | DocumentModelType>((resolve) => {
            api()
                .put(`/api/settings/document-model/${model_id}`, model)
                .then((resp) => {
                    resolve(resp.data.model);
                })
                .catch((err) => {
                    resolve({ code: err.response.status, message: err.response.data.message, error: true })
                });
        });
    }

    const removeModel = async (model_id: number) => {
        return new Promise<ResponseErrorType | boolean>((resolve) => {
            api()
                .del(`/api/settings/document-model/${model_id}`)
                .then((resp) => {
                    resolve(resp.data.success);
                })
                .catch((err) => {
                    resolve({ code: err.response.status, message: err.response.data.message, error: true })
                });
        });
    }

    const createModel = async (model: DocumentModelType) => {
        return new Promise<ResponseErrorType | DocumentModelType>((resolve) => {
            api()
                .post(`/api/settings/document-model`, model)
                .then((resp) => {
                    resolve(resp.data.model);
                })
                .catch((err) => {
                    resolve({ code: err.response.status, message: err.response.data.message, error: true })
                });
        });
    }

    const list = async (medical_record_id: number) => {
        return new Promise<boolean | DocumentType[]>((resolve) => {
            api()
                .get(`/api/medical-record/${medical_record_id}/documents`)
                .then((resp) => {
                    resolve(resp.data);
                })
                .catch(() => resolve(false));
        });
    }

    const get = async (medical_record_id: number, exam_id: number) => {
        return new Promise<ExamType | boolean>((resolve) => {
            api()
                .get(`/api/medical-record/${medical_record_id}/exam/${exam_id}`)
                .then((resp) => {
                    resolve(resp.data);
                })
                .catch(() => resolve(false));
        });
    }

    const getModels = async (type: string) => {
        return new Promise<DocumentModelType[] | boolean>((resolve) => {
            api()
                .get(`/api/configuration/document/${type}`)
                .then((resp) => {
                    resolve(resp.data);
                })
                .catch(() => resolve(false));
        });
    }

    const remove = async (couple_id: number) => {
        return new Promise<boolean>((resolve) => {
            api()
                .del(`/api/couple/${couple_id}`)
                .then((resp) => {
                    resolve(true);
                })
                .catch(() => resolve(false));
        });
    }

    const getDocumentTypes = (): Array<OptionType> => {
        return [
            { label: "Receitas", value: "RECE" },
            { label: "Atestados", value: "ATES" },
            { label: "Exames", value: "EXAM" },
        ];
    }

    return {
        create,
        update,
        remove,
        list,
        get,
        getDocumentTypes,
        getModels,
        updateModel,
        createModel,
        removeModel
    };
}